<template>
<v-list class="pa-0">
  <v-list-tile v-for="item in items" :key="item.name">
    <v-list-tile-action>
      <v-icon :color="item.colorIcon">{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title :class="item.classTitle">{{ item.displayValue }}</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</v-list>
</template>

<script>
export default {
  name: 'DeviceDetail',
  props: {
    item: {
      type: Object,
      required: true
    },
    eventlog: {
      type: Object
    }
  },
  computed: {
    items() {
      return [{
        name: 'hostname',
        icon: 'router',
        displayValue: this.item.hostname || '---'
      }, {
        name: 'id',
        icon: 'vpn_key',
        displayValue: this.item.key || '---'
      }, {
        name: 'battery',
        icon: 'battery_full',
        displayValue: this.battery || '---'
      }, {
        name: 'updated_time',
        icon: 'alarm',
        colorIcon: this.isOffline ? 'red' : undefined,
        classTitle: this.isOffline ? 'red--text' : undefined,
        displayValue: this.updatedTime || '---'
      }]
    },
    battery() {
      switch (this.item.battery) {
        case -1:
        case 255:
          return this.$t('device.battery_plug_in');
        case 0:
        case 238:
          return this.$t('device.battery_exhausted');
        default:
          return `${this.item.battery} %`;
      }
    },
    updatedTime() {
      let t = (this.eventlog || {}).timestamp;
      if (t) {
        return new Date(t * 1000).toLocaleString();
      }
    },
    isOffline() {
      let t = (this.eventlog || {}).timestamp || 0;
      return new Date().getTime() - t * 1000 > 24 * 60 * 60 * 1000;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceDetail.vue